export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-2xl text-background-50 mb-3 block">51动漫</span>
            <p className="text-xs md:text-sm text-background-50/60 leading-relaxed">
              海量韩漫日漫国漫免费全集平台，支持追更下拉式阅读，让好动漫触手可及。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-3 md:mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门专题', href: '#index' },
                { label: '精选推荐', href: '#carousel' },
                { label: '新番速递', href: '#cards' },
                { label: '热度榜单', href: '#ranking' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs md:text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(link.href);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-3 md:mb-4">服务支持</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '联系投稿', href: '#contact' },
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
                { label: 'APP下载', href: '#app' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs md:text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(link.href);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-3 md:mb-4">合作伙伴</h4>
            <p className="text-xs md:text-sm text-background-50/40 leading-relaxed">
              合作品牌信息即将公布，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 51动漫. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); const el = document.querySelector('#hero'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}>
              <i className="ri-arrow-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}